import { useAppContext, useAppDispatch } from '../../../providers';
import { ACTIVE_TAB } from '../../../providers/AppProvider/types';

import * as classes from './Tabs.module.css';

/**
 * Tabs molecule
 * @param {Local.TabsProps} props - Component props
 */
export const Tabs = ({ tabs }) => {
  const dispatch = useAppDispatch();
  const { activeTab } = useAppContext();

  /**
   * Handles changes to the active tab.
   * @param {React.MouseEvent<HTMLButtonElement> & { currentTarget: { dataset: {tab: string} } }} event - The change event object.
   * @returns {void}
   */
  const handleTabChange = ({ currentTarget: { dataset } }) => {
    const { tab } = dataset;

    dispatch({ type: ACTIVE_TAB, payload: tab });
  };

  return (
    <div data-testid='tabs-container' className={classes.container}>
      {tabs.map((tab) => (
        <button
          key={tab}
          data-testid={`tab-${tab}`}
          className={`${classes.tab} ${activeTab === tab ? classes.active : ''}`}
          type='button'
          data-tab={tab}
          onClick={handleTabChange}
        >
          <p>{tab}</p>
        </button>
      ))}
    </div>
  );
};
